import API from '@/views/Fdc/Apis/'
import _ from 'lodash'
import EqpCopyModal from '@/views/Fdc/EqpInfo/Components/EqpCopyModal'

/**
 * TODO: 수정해야 할 항목 정리
 */
// FIXME: 1.

/**
 * Data Collection > Data Collection Plan
 * Data Collection Plan 관리
 */
export default {
  name: 'DataCollectionPlan',
  components: {
    'eqp-copy-modal': EqpCopyModal // 기준 정보 Copy Modal
  },
  beforeMount () {
    this.initColumns()
  },
  computed: {
    // ...mapGetters([
    //   'user',
    //   'authed'
    // ])
  },
  watch: {
  },
  methods: {
    /**
     * Columns initialize
     */
    initColumns () {
      const useYn = ['Y', 'N']
      this.dcColumns = [
        { headerName: this.$t('fdc.COMMON.COLUMN.PLAN_NAME'), field: 'planName', width: 150, required: true, modifiable: false, checkboxSelection: true, headerCheckboxSelection: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.USABLE'), field: 'useYn', width: 80, required: true, editable: true, cellEditor: 'agSelectCellEditor', cellEditorParams: { values: useYn } },
        { headerName: this.$t('fdc.COMMON.COLUMN.IDLE_APPLY'), field: 'idleApplyYn', width: 120, required: true, editable: true, cellEditor: 'agSelectCellEditor', cellEditorParams: { values: useYn } },
        { headerName: this.$t('fdc.COMMON.COLUMN.LOT_TIMEOUT'), field: 'lotTimeout', width: 110, required: true, editable: true, type: 'numericColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.SUBST_TIMEOUT'), field: 'substTimeout', width: 130, required: true, editable: true, type: 'numericColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.TRACE_TIMEOUT'), field: 'traceTimeout', width: 130, required: true, editable: true, type: 'numericColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.TARGET'), field: 'targetId', width: 100, required: true, editable: true, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.SOURCE'), field: 'sourceId', width: 100, required: true, editable: true, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.TARGET_URL'), field: 'targetUrl', width: 150, required: true, editable: true, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.EVENT_CMD'), field: 'eventCmd', width: 100, required: true, editable: true, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.TRACE_CMD'), field: 'traceCmd', width: 100, required: true, editable: true, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.REQUEST_URL'), field: 'requestUrl', width: 150, required: true, editable: true, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.REPLY_URL'), field: 'replyUrl', width: 150, required: true, editable: true, hide: true },
        // { headerName: 'Create Date', field: 'createDt', width: '1*', required: true, readOnly: true, type: 'dateTimeColumn', hide: true },
        // { headerName: 'Create User', field: 'createUser', width: '1*', required: true, readOnly: true, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODIFY_TIME'), field: 'modifyDt', width: 180, required: true, type: 'dateTimeColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODIFY_USER'), field: 'modifyUser', width: 110, required: true }
      ]
      this.eventColumns = [
        { headerName: this.$t('fdc.COMMON.COLUMN.CEID'), field: 'ceid', width: 120 },
        { headerName: this.$t('fdc.COMMON.COLUMN.VID_LIST'), field: 'vidList', width: 400 },
        // { headerName: 'Create Date', field: 'createDt', width: '1*', type: 'dateTimeColumn', hide: true },
        // { headerName: 'Create User', field: 'createUser', width: '1*', hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODIFY_TIME'), field: 'modifyDt', width: 180, type: 'dateTimeColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODIFY_USER'), field: 'modifyUser', width: 150 }
      ]
      this.traceColumns = [
        { headerName: this.$t('fdc.COMMON.COLUMN.TRID'), field: 'trid', width: 120 },
        { headerName: this.$t('fdc.COMMON.COLUMN.TRID_MAIN'), field: 'mainYn', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.GROUP_SIZE'), field: 'groupSize', width: 100, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.RUN_INTERVAL'), field: 'runInterval', width: 120 },
        { headerName: this.$t('fdc.COMMON.COLUMN.IDLE_INTERVAL'), field: 'idleInterval', width: 130 },
        { headerName: this.$t('fdc.COMMON.COLUMN.VID_LIST'), field: 'vidList', width: 400 },
        // { headerName: 'Create Date', field: 'createDt', width: '1*', type: 'dateTimeColumn', hide: true },
        // { headerName: 'Create User', field: 'createUser', width: '1*', hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODIFY_TIME'), field: 'modifyDt', width: 180, type: 'dateTimeColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODIFY_USER'), field: 'modifyUser', width: 110 }
      ]
      this.contextColumns = [
        { headerName: this.$t('fdc.COMMON.COLUMN.CONTEXT_NAME'), field: 'contextName', width: 150 },
        { headerName: this.$t('fdc.COMMON.COLUMN.CONTEXT_TYPE'), field: 'contextType', width: 150 },
        { headerName: this.$t('fdc.COMMON.COLUMN.CONTEXT_KEY'), field: 'contextKey', width: 180 },
        { headerName: this.$t('fdc.COMMON.COLUMN.CONTEXT_INDEX'), field: 'contextIndex', width: 120 },
        { headerName: this.$t('fdc.COMMON.COLUMN.CONTEXT_DATA'), field: 'contextData', width: 300 },
        // { headerName: 'Create Date', field: 'createDt', width: '1*', type: 'dateTimeColumn', hide: true },
        // { headerName: 'Create User', field: 'createUser', width: '1*', hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODIFY_TIME'), field: 'modifyDt', width: 180, type: 'dateTimeColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODIFY_USER'), field: 'modifyUser', width: 110 }
      ]
    },
    /**
     * EQP Tree select시 수행하는 method
     * @param {Object} node 선택된 tree node data
     */
    eqpTreeSelected (node) {
      this.selectedTreeNode = node
    },
    /**
     * BRIQUE grid selection change event
     * @param {*} rows selection rows
     */
    gridSelectionChanged (rows) {
      if (rows.length === 1) {
        this.dcCurrentRow = []
        var currentRow = rows[0]
        let node = this.selectedTreeNode
        if (node != null) {
          if (currentRow.planName != null) {
            this.dcCurrentRow.push(currentRow)
            this.searchSubPlanList(node.detail.fab, node.detail.eqpId, currentRow.planName)
          }
        }
      } else {
        // TODO: 처리 필요시 추가
      }
    },
    /**
     * 각 plan 화면으로 연동 (Event, Trace, Context)
     * 선택된 tab에 해당하는 화면으로 연동합니다.
     * 연동 시 선택된 Data Collection Plan과 Plan의 하위 data (Event, Trace, Context)도 연동되는 화면으로 전달합니다.
     */
    editSubPlan () {
      if (this.searchTreeNode && this.searchTreeNode.length !== 0) {
        let selectEqpVo = this.searchTreeNode.detail

        if (this.dcCurrentRow.length > 0) { // if (this.dcPlanGrid.selectedItems.length > 0) {
          if (this.dcCurrentRow[0].planName != null) { // if (this.dcPlanGrid.selectedItems[0].planName != null) {
            let fab = selectEqpVo.fab
            let eqpId = selectEqpVo.eqpId
            let planName = this.dcCurrentRow[0].planName // this.dcPlanGrid.selectedItems[0].planName
            let trid = ''
            let name = ''

            if (this.tabIndex === 0) {
              // event
              name = 'event-collection-plan'
            } else if (this.tabIndex === 1) {
              // trace
              name = 'eqp-context-info' // 'trace-collection-plan'
              const selectedItem = this.$refs.tracePlanGrid.gridApi.getSelectedRows()
              if (this.traceRowData.length > 0 && selectedItem.length > 0) { // this.tracePlanGrid.collectionView.items.length > 0) {
                // 하위 trace plan grid에 데이터가 존재하거나 선택하였을 경우만 처리.
                trid = selectedItem[0].trid // this.tracePlanGrid.selectedItems[0].trid
              }
            } else if (this.tabIndex === 2) {
              // context
              name = 'context-mapping-plan'
            } else {
              return
            }

            let routeData = this.$router.resolve(
              {
                name: name,
                query: {
                  fab: fab,
                  eqpId: eqpId,
                  planName: planName,
                  trid: trid
                }
              }
            )
            window.open(routeData.href, '_blank')
            // this.dcPlanGrid.invalidate()
          }
        }
      }
    },
    /**
     * Data Collcetion Plan 검색
     */
    searchProcess () {
      if (this.selectedTreeNode.length === 0) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['EQP ID']))
        return
      }
      let node = this.selectedTreeNode
      if (node.detail.eqpId === '') {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['EQP ID']))
        return
      }
      this.searchTreeNode = this.selectedTreeNode

      this.$commonUtil.setStoreEqpTree(
        this.selectedTreeNode,
        this.$refs.fdcEqpTree.treeType
      )

      this.searchDataCollectionPlanList(node.detail.fab, node.detail.eqpId)
    },
    /**
     * Data Collection Plan 목록 조회
     * @param {String} fab Fab
     * @param {String} eqpId EQP ID
     */
    async searchDataCollectionPlanList (fab, eqpId) {
      this.dcRowData = []
      // this.searchProcess()
      this.eventRowData = []
      this.traceRowData = []
      this.contextRowData = []

      this.dcSelRowIdx = -1

      let payload = {
        fab: fab,
        eqpId: eqpId
      }
      let data = await API.Collection.getCollectionPlans(payload)
      this.dcRowData = data
      // TODO: 좀더 고려해볼 항목
      setTimeout(() => {
        this.$refs.dcPlanGrid.setFirstRowSelected()
      })
      // this.dcOrgData = data
      // console.log(this.dcRowData)
    },
    /**
     * Event/Trace/Context Mapping Plan 목록 조회
     * @param {String} fab Fab
     * @param {String} eqpId EQP ID
     * @param {String} planName Plan Name
     */
    async searchSubPlanList (fab, eqpId, planName) {
      this.eventRowData = []
      this.traceRowData = []
      this.contextRowData = []

      let payload = {
        fab: fab,
        eqpId: eqpId,
        planName: planName
      }
      let eventData = await API.Collection.getEventPlans(payload)
      this.eventRowData = eventData

      let traceData = await API.Collection.getTracePlans(payload)
      this.traceRowData = traceData

      let contextData = await API.Collection.getContextPlans(payload)
      this.contextRowData = contextData
    },
    /**
     * Data Collection Plan Grid에 check된 row count 확인
     * @returns {Boolean} check된 row가 있는지 여부
     */
    hasCheckedRows () {
      if (!this.$refs.dcPlanGrid) {
        return 0
      }
      return this.$refs.dcPlanGrid.checkedRowCount > 0
    },
    /**
     * Add Button 활성화 여부 결정
     * @returns {Boolean} Add Button 활성화 여부
     * 검색된 tree node 있는지 여부를 판단하여 Add Button 활성화 여부를 결정합니다.
     */
    existRowsDcPlan () {
      if (!this.searchTreeNode.detail) {
        return false
      } else {
        let selectEqpVo = this.searchTreeNode.detail
        if (selectEqpVo.fab !== null && selectEqpVo.eqpId !== null) {
          return true
        }
        return false
      }
    },
    /**
     * Edit Button 활성화 여부 결정
     * @returns {Boolean} Edit Button 활성화 여부
     * 선택된 Data Collection Plan이 있는지 여부를 판단하여 Edit Button 활성화 여부를 결정합니다.
     */
    existSelRowDcPlan () {
      if (!this.existRowsDcPlan()) {
        return false
      } else {
        // FIXME: 아래 항목 조건 생각해볼 것
        if ((this.dcRowData === null || this.dcRowData === undefined) || this.dcRowData.length <= 0) {
        // if ((this.dcRowData === null || this.dcRowData === undefined) || this.dcPlanGrid.collectionView.items.length <= 0) {
          return false
        }
      }
      return true
    },
    /**
     * Data Collection Plan Grid에 신규 Row 추가
     */
    newRowAddDCPlan () {
      let selectEqpVo = this.searchTreeNode.detail
      let arr =
        {
          fab: selectEqpVo.fab,
          eqpId: selectEqpVo.eqpId,
          // planNme: null,
          useYn: 'N',
          idleApplyYn: 'N',
          lotTimeout: 3600,
          substTimeout: 3600,
          traceTimeout: 100,
          targetUrl: '',
          requestUrl: '',
          replyUrl: '',
          // createUser: this.user.userId,
          // modifyUser: this.user.userId,
          addRow: true
        }

      // let status = {
      //   checked: true,
      //   modified: false,
      //   added: true
      // }
      // this.$refs.dcPlanGrid.addRows(arr, status)
      this.$refs.dcPlanGrid.addRowOne(arr)
    },
    /* _updateComboBoxInGrid () {
      if (this.dcPlanGrid) {
        let colUseYn = this.dcPlanGrid.columns.getColumn('useYn')
        if (colUseYn) {
          colUseYn.dataMapEditor = true
          colUseYn.dataMap = this._buildDataMap(this.useYnList, 'useYn')
        }
        let colIdleApplyYn = this.dcPlanGrid.columns.getColumn('idleApplyYn')
        if (colIdleApplyYn) {
          colIdleApplyYn.dataMapEditor = true
          colIdleApplyYn.dataMap = this._buildDataMap(this.useYnList, 'idleApplyYn')
        }
      }
      if (this.eventPlanGrid) {
        let colMainYn = this.eventPlanGrid.columns.getColumn('mainYn')
        if (colMainYn) {
          // colMainYn.dataMapEditor = true
          colMainYn.dataMap = this._buildDataMap(this.useYnList, 'mainYn')
        }
      }
    },
    _buildDataMap (items, keyName) {
      let map = []
      for (let i = 0; i < items.length; i++) {
        map.push({
          key: items[i][keyName],
          value: items[i][keyName]
        })
      }
      return new wjcGrid.DataMap(map, 'key', 'value')
    }, */
    /**
     * Data Collection Plan 재조회
     */
    refreshDCPlanGrid () {
      if (this.searchTreeNode) {
        let selectEqpVo = this.searchTreeNode.detail
        this.searchDataCollectionPlanList(selectEqpVo.fab, selectEqpVo.eqpId)
      }
    },
    refreshDcPlanList () {
      this.$refs.dcPlanGrid.onClickRefreshData()
    },
    /**
     * Data Collcetion Plan Start (ALL)
     */
    startAll () {
      // execDataCollectionPlan
      // payload:execCmd, execType, listDCPlan

      // DCPLAN_EXE_CMD  : START, STOP
      // DCPLAN_EXE_TYPE : ALL, EVENT, TRACE
      // this.execDCPlan('ALL')
      this.execDCPlan(this.execCmd.START, this.execType.ALL)
    },
    /**
     * Data Collcetion Plan Start (EVENT)
     */
    startEvent () {
      this.execDCPlan(this.execCmd.START, this.execType.EVENT)
    },
    /**
     * Data Collcetion Plan Start (TRACE)
     */
    startTrace () {
      this.execDCPlan(this.execCmd.START, this.execType.TRACE)
    },
    /**
     * Data Collcetion Plan Stop (ALL)
     */
    stopAll () {
      this.execDCPlan(this.execCmd.STOP, this.execType.ALL)
    },
    /**
     * Data Collcetion Plan Stop (EVENT)
     */
    stopEvent () {
      this.execDCPlan(this.execCmd.STOP, this.execType.EVENT)
    },
    /**
     * Data Collcetion Plan Stop (TRACE)
     */
    stopTrace () {
      this.execDCPlan(this.execCmd.STOP, this.execType.TRACE)
    },
    /**
     * Data Collection Plan Start/Stop 실행
     * @param {String} cmd START / STOP
     * @param {String} type ALL / EVENT / TRACE
     */
    async execDCPlan (cmd, type) {
      const self = this
      const checkedRows = this.$refs.dcPlanGrid.getCheckedRows() // this.$refs.dcPlanGrid.checkedRows
      // const allRows = this.$refs.dcPlanGrid.rows

      // console.log(cmd, type)

      let execRows = []

      if (checkedRows < 1) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_NO_DATA_SELECTED', ['Item']))
        return
      }

      // allRows.some(row => {
      checkedRows.some(row => {
        // const rowStatus = row.dataItem._status
        // // 변경되어 선택된 저장 대상
        // if (rowStatus.checked && (!rowStatus.added && !rowStatus.modified)) {
        //   const item = _.clone(row.dataItem)
        //   delete item['_status']
        //   execRows.push(item)
        // }
        const rowStatus = row.briqueGridCud
        // 변경되어 선택된 저장 대상 << 기존 주석. 이 대상을 제외한 경우 같음..
        console.log('rowStatus', rowStatus)
        if (!rowStatus || (!rowStatus === 'C' && !rowStatus === 'U')) {
          execRows.push(row)
        }
      })

      // console.log(execRows)

      // 실행할 data collection plan이 없거나, 저장되지 않은 data collection plan이 존재할 경우
      if (execRows < 1 || !_.isEqual((execRows.length), checkedRows.length)) {
        this.$dialog.alert(this.$t('fdc.DATA_COLLECTION.MESSAGE.FAILED_UNSAVED_EXEC'))
        return
      }

      const successMessage = this.$t('fdc.COMMON.MESSAGE.SUCCEED_EXEC_REQ')
      const failMessage = this.$t('fdc.COMMON.MESSAGE.FAILED_EXEC_REQ')

      let payload = {
        execCmd: cmd,
        execType: type,
        listDCPlan: execRows
      }

      // console.log(payload)

      this.$dialog.confirm({
        message: this.$t('fdc.COMMON.MESSAGE.CONFIRM_MULTI_EXEC'),
        onConfirm: async function () {
          const responseData = await API.Collection.runCollectionPlan(payload)
          if (responseData != null && responseData.status === 200 && !_.isUndefined(responseData.data) && _.isEqual(responseData.data, 'SUCCESS')) {
            self.$dialog.alert(successMessage)
            console.log(responseData)
          } else {
            // console.log(responseData.data)
            if (!_.isUndefined(responseData) || !_.isUndefined(responseData.data)) {
              self.$dialog.alert(failMessage + ' : ' + responseData.data)
            } else {
              self.$dialog.alert(failMessage)
            }
          }
        }
        // onCancel: function () {}
      })
    },
    /**
     * Data Collection Plan 저장
     */
    async saveDCPlan () {
      // console.log('saveDCPlan() call!')
      const self = this
      const allRows = this.$refs.dcPlanGrid.getAllRows() // this.$refs.dcPlanGrid.rows
      const checkedRows = this.$refs.dcPlanGrid.getCheckedRows() // this.$refs.dcPlanGrid.checkedRows
      const totalModifiedRows = this.$refs.dcPlanGrid.getUpdatedRows() // this.$refs.dcPlanGrid.totalModifiedRows
      const addedRows = this.$refs.dcPlanGrid.getAddedRows()
      let saveRows = []

      // let updateRows = []
      // let addRows = []

      if (checkedRows < 1) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_NO_DATA_SELECTED'))
        return
      }
      // let modifiedRows = this.$refs.dcPlanGrid.modifiedRows
      // let addedRows = this.$refs.dcPlanGrid.addedRows

      // allRows.some(row => {
      //   const rowStatus = row.dataItem._status
      //   // 변경되어 선택된 저장 대상
      //   if (rowStatus.checked && (rowStatus.added || rowStatus.modified)) {
      //     const item = _.clone(row.dataItem)
      //     delete item['_status']
      //     saveRows.push(item)
      //   }
      // })
      checkedRows.some(row => {
        const rowStatus = row.briqueGridCud
        // 변경되어 선택된 저장 대상
        if (rowStatus === 'C' || rowStatus === 'U') {
          saveRows.push(row)
        }
      })

      // 변경된 데이터가 없다.
      if (saveRows < 1) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_NO_DATA_CHANGED'))
        return
      }

      let confirmMessage = ''
      const successMessage = this.$t('fdc.COMMON.MESSAGE.SUCCEED_SAVE')
      const failMessage = this.$t('fdc.COMMON.MESSAGE.FAILED_SAVE')
      if (!_.isEqual((saveRows.length), (addedRows.length + totalModifiedRows.length))) {
        confirmMessage = this.$t('fdc.COMMON.MESSAGE.CONFIRM_UNCHECKED_CHANGED_DATA')
      }
      confirmMessage += 'TOTAL ' + checkedRows.length + ' ' + this.$t('fdc.COMMON.MESSAGE.CONFIRM_MULTI_SAVE')

      if (this.isUsableValidationCheck(allRows) === false) {
        return
      }
      if (this.saveValidationCheck(saveRows) === false) {
        return
      }

      let payload = saveRows

      this.$dialog.confirm({
        message: confirmMessage,
        onConfirm: async function () {
          const responseData = await API.Collection.addCollectionPlan(payload)
          if (responseData != null && responseData.status === 200) {
            self.$dialog.alert(successMessage)
            // self.dcRowData.forEach(row => {
            //   row['_status'].added = false
            //   row['_status'].checked = false
            //   row['_status'].modified = false
            // })
            // self.dcPlanGrid.collectionView.refresh()
            self.refreshDCPlanGrid()
          } else {
            self.$dialog.alert(failMessage)
          }
        }
        // onCancel: function () {}
      })
    },
    /**
     * Data Collection Plan중 Use YN이 1개인지 여부 체크
     * @param {Array} rows grid row 배열
     * @returns {Boolean} 체크 결과
     */
    isUsableValidationCheck (rows) {
      let arrRows = []
      rows.some(row => {
        if (_.isEqual(row.useYn, 'Y')) {
          arrRows.push(row.planName) // (row._idx)
        }
      })
      if (arrRows.length > 1) {
        this.$dialog.alert(this.$t('fdc.DATA_COLLECTION.MESSAGE.NOT_MULTI_USABLE'))
        return false
      }
      return true
    },
    /**
     * Data Collection Plan Save Validation
     * @param {Array} rows grid row 배열
     * @returns {Boolean} validation 성공 여부
     */
    saveValidationCheck (rows) {
      for (let i in rows) {
        if (!rows[i].fab || rows[i].fab.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['FAB']))
          return false
        } else if (!rows[i].eqpId || rows[i].eqpId.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['EQP ID']))
          return false
        } else if (!rows[i].planName || rows[i].planName.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['PLAN NAME']))
          return false
        }
      }
      return true
    },
    /**
     * Data Collection Plan 삭제
     */
    async deleteDCPlan () {
      const that = this
      const checkedRows = this.$refs.dcPlanGrid.getCheckedRows() // []
      // const allRows = this.$refs.dcPlanGrid.rows
      let addedRow = []
      let deleteRow = []

      // allRows.some(row => {
      //   const rowStatus = row.dataItem._status
      //   if (rowStatus.checked) {
      //     checkedRows.push(row.dataItem)
      //     if (rowStatus.added) {
      //       addedRow.push(row.dataItem)
      //     } else {
      //       const item = _.clone(row.dataItem)
      //       delete item['_status']
      //       deleteRow.push(item)
      //     }
      //   }
      // })
      checkedRows.some(row => {
        if (row.briqueGridCud && row.briqueGridCud === 'C') {
          addedRow.push(row)
        } else {
          deleteRow.push(row)
        }
      })

      if (checkedRows < 1) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_NO_DATA_SELECTED'))
      }

      const confirmMessage = this.$t('fdc.COMMON.MESSAGE.CONFIRM_MULTI_DELETE', [checkedRows.length])
      const completeMessage = this.$t('fdc.COMMON.MESSAGE.SUCCEED_DELETE')

      let payload = deleteRow

      this.$dialog.confirm({
        message: confirmMessage,
        onConfirm: async function () {
          if (deleteRow.length > 0) {
            await API.Collection.putCollectionPlan(payload)
          } else {
          }
          // checkedRows.forEach(element => {
          //   that.dcPlanGrid.collectionView.remove(element)
          // })
          // that.dcPlanGrid.collectionView.refresh()
          that.$dialog.alert(completeMessage)
          that.refreshDCPlanGrid()
        }
      })
    },
    /**
     * 빈값 체크
     * @param {*} value data
     * @returns {Boolean} 체크 결과
     */
    isEmpty (value) {
      if (value === '' || value == null || value === undefined || (value != null && typeof value === 'object' && !Object.keys(value).length)) {
        return true
      } else {
        return false
      }
    },
    /**
     * 기준 정보 Copy Modal 열기
     */
    openCopyModal () {
      this.eqpCopyModal.visible = true
    },
    /**
     * 기준 정보 Copy Modal 닫기
     */
    resetCopyModalData (value) {
      this.eqpCopyModal.visible = value
    }
  },
  data () {
    return {
      dcColumns: [], // Data Collection Plan grid column 배열
      eventColumns: [], // Event Collection Plan grid column 배열
      traceColumns: [], // Trace Collection Plan grid column 배열
      contextColumns: [], // Context Mapping Plan grid column 배열
      defaultColDef: {
        filter: true,
        sortable: true,
        resizable: true
      }, // BRIQUE Grid column default setting
      // dcColumns: [
      //   { label: this.$t('fdc.COMMON.COLUMN.PLAN_NAME'), binding: 'planName', width: 150, required: true, readOnly: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.USABLE'), binding: 'useYn', width: 80, required: true, readOnly: false, dataMap: ['Y', 'N'] },
      //   { label: this.$t('fdc.COMMON.COLUMN.IDLE_APPLY'), binding: 'idleApplyYn', width: 120, required: true, readOnly: false, dataMap: ['Y', 'N'] },
      //   { label: this.$t('fdc.COMMON.COLUMN.LOT_TIMEOUT'), binding: 'lotTimeout', width: 110, required: true, readOnly: false, dataType: 'Number' },
      //   { label: this.$t('fdc.COMMON.COLUMN.SUBST_TIMEOUT'), binding: 'substTimeout', width: 130, required: true, readOnly: false, dataType: 'Number' },
      //   { label: this.$t('fdc.COMMON.COLUMN.TRACE_TIMEOUT'), binding: 'traceTimeout', width: 130, required: true, readOnly: false, dataType: 'Number' },
      //   { label: this.$t('fdc.COMMON.COLUMN.TARGET'), binding: 'targetId', width: 100, required: true, readOnly: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.SOURCE'), binding: 'sourceId', width: 100, required: true, readOnly: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.TARGET_URL'), binding: 'targetUrl', width: 150, required: true, readOnly: false, visible: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.EVENT_CMD'), binding: 'eventCmd', width: 100, required: true, readOnly: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.TRACE_CMD'), binding: 'traceCmd', width: 100, required: true, readOnly: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.REQUEST_URL'), binding: 'requestUrl', width: 150, required: true, readOnly: false, visible: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.REPLY_URL'), binding: 'replyUrl', width: 150, required: true, readOnly: false, visible: false },
      //   // { label: 'Create Date', binding: 'createDt', width: '1*', required: true, readOnly: true, dataType: 'Date', format: 'yyyy.MM.dd HH:mm:ss', visible: false },
      //   // { label: 'Create User', binding: 'createUser', width: '1*', required: true, readOnly: true, visible: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.MODIFY_TIME'), binding: 'modifyDt', width: 180, required: true, readOnly: true, dataType: 'Date', format: 'yyyy.MM.dd HH:mm:ss' },
      //   { label: this.$t('fdc.COMMON.COLUMN.MODIFY_USER'), binding: 'modifyUser', width: 110, required: true, readOnly: true }
      // ], // Data Collection Plan grid column 배열
      // eventColumns: [
      //   { label: this.$t('fdc.COMMON.COLUMN.CEID'), binding: 'ceid', width: 120, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.VID_LIST'), binding: 'vidList', width: 400, readOnly: true },
      //   // { label: 'Create Date', binding: 'createDt', width: '1*', readOnly: true, dataType: 'Date', format: 'yyyy.MM.dd HH:mm:ss', visible: false },
      //   // { label: 'Create User', binding: 'createUser', width: '1*', readOnly: true, visible: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.MODIFY_TIME'), binding: 'modifyDt', width: 180, readOnly: true, dataType: 'Date', format: 'yyyy.MM.dd HH:mm:ss' },
      //   { label: this.$t('fdc.COMMON.COLUMN.MODIFY_USER'), binding: 'modifyUser', width: 150, readOnly: true }
      // ], // Event Collection Plan grid column 배열
      // traceColumns: [
      //   { label: this.$t('fdc.COMMON.COLUMN.TRID'), binding: 'trid', width: 120, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.TRID_MAIN'), binding: 'mainYn', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.GROUP_SIZE'), binding: 'groupSize', width: 100, readOnly: true, visible: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.RUN_INTERVAL'), binding: 'runInterval', width: 120, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.IDLE_INTERVAL'), binding: 'idleInterval', width: 130, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.VID_LIST'), binding: 'vidList', width: 400, readOnly: true },
      //   // { label: 'Create Date', binding: 'createDt', width: '1*', readOnly: true, dataType: 'Date', format: 'yyyy.MM.dd HH:mm:ss', visible: false },
      //   // { label: 'Create User', binding: 'createUser', width: '1*', readOnly: true, visible: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.MODIFY_TIME'), binding: 'modifyDt', width: 180, readOnly: true, dataType: 'Date', format: 'yyyy.MM.dd HH:mm:ss' },
      //   { label: this.$t('fdc.COMMON.COLUMN.MODIFY_USER'), binding: 'modifyUser', width: 110, readOnly: true }
      // ], // Trace Collection Plan grid column 배열
      // contextColumns: [
      //   { label: this.$t('fdc.COMMON.COLUMN.CONTEXT_NAME'), binding: 'contextName', width: 150, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.CONTEXT_TYPE'), binding: 'contextType', width: 150, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.CONTEXT_KEY'), binding: 'contextKey', width: 180, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.CONTEXT_INDEX'), binding: 'contextIndex', width: 120, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.CONTEXT_DATA'), binding: 'contextData', width: 300, readOnly: true },
      //   // { label: 'Create Date', binding: 'createDt', width: '1*', readOnly: true, dataType: 'Date', format: 'yyyy.MM.dd HH:mm:ss', visible: false },
      //   // { label: 'Create User', binding: 'createUser', width: '1*', readOnly: true, visible: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.MODIFY_TIME'), binding: 'modifyDt', width: 180, readOnly: true, dataType: 'Date', format: 'yyyy.MM.dd HH:mm:ss' },
      //   { label: this.$t('fdc.COMMON.COLUMN.MODIFY_USER'), binding: 'modifyUser', width: 110, readOnly: true }
      // ], // Context Mapping Plan grid column 배열
      dcCurrentRow: [], // Data Collection Plan current selected row
      dcRowData: [], // Data Collection Plan row data
      // dcOrgData: [],
      eventRowData: [], // Event Collection Plan row data
      traceRowData: [], // Trace Collection Plan row data
      contextRowData: [], // Context Mapping Plan row data
      dcSelRowIdx: -1, // Data Collection Plan select row index
      selectedTreeNode: [], // 선택된 EQP Tree node
      searchTreeNode: [], // 검색한 EQP Tree node
      collectionViewOptions: {
        // groupDescriptions: ['eqpId']
      }, // grid collectionView Option
      tabIndex: 0, // tab index
      execCmd: {
        START: 'START',
        STOP: 'STOP'
      }, // Data Collection Plan exec commnad
      execType: {
        ALL: 'ALL',
        TRACE: 'TRACE',
        EVENT: 'EVENT'
      }, // Data Collection Plan exec type
      // searchString: '',
      eqpCopyModal: { visible: false } // 기준정보 Copy Modal 표시 여부
    }
  }
}
